import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { ProductionSidePanelDetails } from "./ProductionSidePanelDetails";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";

import { useOpenSidePanel } from "../SidePanel";

interface ProductionSidePanelProps {
  productionId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const ProductionSidePanel = (props: ProductionSidePanelProps) => {
  if (!site.permissions.tour.canAccessDetails) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    detailUrl={routes.production_Detail(props.productionId).absolute}
    apiCall={() => window.CoreApi.Production.GetSidePanelData(props.productionId)}
    apiKey="production"
    entityId={props.productionId}
    title={site.currentEnvironment.tour.singular}
    footerContent={<ButtonPrimary href={routes.production_Detail(props.productionId).absolute} label={RESX.Buttons.DetailView} />}
    trigger={<RightClickMenu menuItems={rightMenuForSidePanel(routes.production_Detail(props.productionId).absolute)}>{props.trigger}</RightClickMenu>}
  >
    {(data) => <ProductionSidePanelDetails
      production={data.tour}
      freeFieldCategories={data.freeFieldCategories}
    />}
  </DetailSidePanel>;
};

export const useOpenProductionSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openProductionSidePanel = React.useCallback((productionId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Production.GetSidePanelData(productionId)}
      apiKey="production"
      entityId={productionId}
      title={site.currentEnvironment.tour.singular}
      footerContent={
        <ButtonPrimary href={routes.production_Detail(productionId).absolute} label={RESX.Buttons.DetailView} />
      }
      skipSidePanelBase
    >
      {(data) => <ProductionSidePanelDetails
        production={data.tour}
        freeFieldCategories={data.freeFieldCategories}
      />}
    </DetailSidePanel>, `production-side-${productionId}`);

  }, [openSidePanel]);

  return openProductionSidePanel;
}